<template>
  <div class="ti">
    <div style="margin-left: 20px; margin-top: 20px; margin-bottom: 20px;background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  justify-content: center;
  padding:10px 10px;
  position: sticky;
  top: 0;
  left: 0;
  z-index:999">
      <el-row>
        <el-col :span="2">
          <el-checkbox :indeterminate="isIndeterminate" v-model="search.checkAll" @change="handleCheckAllChange">
            全选
            <template v-if="activeName != 'abnormalWork'">
              <el-badge class="mark" :value="status_total['total']"/>
            </template>
            <template v-else>
              <el-badge class="mark" :value="abnormal_status_total['total']"/>
            </template>
          </el-checkbox>
        </el-col>
        <el-col :span="19">
          <el-checkbox-group v-model="search.select_status" @change="handleCheckedCitiesChange">
            <template v-for="(item, index) in search.statusList">
              <el-checkbox :label="item" :key="item">
                {{ item }}
                <template v-if="activeName != 'abnormalWork'">
                  <el-badge v-if="index == 0" class="mark" :value="status_total['status_0']"/>
                  <el-badge v-if="index == 1" class="mark" :value="status_total['status_2']"/>
                  <el-badge v-if="index == 2" class="mark" :value="status_total['status_7']"/>
                  <el-badge v-if="index == 3" class="mark" :value="status_total['status_3']"/>
                  <el-badge v-if="index == 4" class="mark" :value="status_total['status_3000']"/>
                  <el-badge v-if="index == 5" class="mark" :value="status_total['status_5']"/>
                  <el-badge v-if="index == 6" class="mark" :value="status_total['status_4']"/>
                </template>
                <template v-else>
                  <el-badge v-if="index == 0" class="mark" :value="abnormal_status_total['status_0']"/>
                  <el-badge v-if="index == 1" class="mark" :value="abnormal_status_total['status_2']"/>
                  <el-badge v-if="index == 2" class="mark" :value="abnormal_status_total['status_7']"/>
                  <el-badge v-if="index == 3" class="mark" :value="abnormal_status_total['status_3']"/>
                  <el-badge v-if="index == 4" class="mark" :value="abnormal_status_total['status_3000']"/>
                  <el-badge v-if="index == 5" class="mark" :value="abnormal_status_total['status_5']"/>
                  <el-badge v-if="index == 6" class="mark" :value="abnormal_status_total['status_4']"/>
                </template>
              </el-checkbox>
            </template>

          </el-checkbox-group>
        </el-col>
        <el-col :span="3">
          <!--          <el-button size="mini" style="color: #FFFFFF" type="primary" @click="searchData">搜索</el-button>-->
          <!--        <el-button size="mini" style="color: #FFFFFF" type="success">导出</el-button>-->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <SelectCdjProjectHeader :items="['type_id', 'place_id','region_id','project_id', 'area_id']" @onHeader="onHeader"></SelectCdjProjectHeader>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          编号：
          <el-input size="mini" v-model="search.services_id" clearable placeholder="请输入编号" style="width: 80%"
                    @input="searchData"></el-input>
        </el-col>
        <el-col :span="4">
          类型：
          <el-select v-model="search.site" placeholder="请选择类型" size="mini" clearable @change="searchData">
            <el-option label="-所有类型-" value="" />
            <el-option v-for="item in site_list" :key="item.value" :label="item.name" :value="item.value"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          预警级别：
          <el-select v-model="search.is_timeout" placeholder="请选择预警级别" clearable size="mini"
                     @change="searchData">
            <el-option label="-全部-" value=""></el-option>
            <el-option label="一级预警" value="1"></el-option>
            <el-option label="二级预警" value="2"></el-option>
            <el-option label="三级预警" value="3"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" v-if="activeName != 'abnormalWork'">
          工单来源：
          <el-select v-model="search.member_type" placeholder="请选择工单来源" clearable size="mini"
                     @change="searchData">
            <el-option label="-所有来源-" value=""></el-option>
            <!-- <el-option label="业主工单(含投诉)" value="1"></el-option> -->
            <el-option label="物业工单" value="2"></el-option>
            <el-option label="业主工单" value="1_w"></el-option>
            <el-option label="业主投诉" value="1_8"></el-option>
            <el-option label="舆情工单" value="8_w"></el-option>
            <el-option label="代办工单" value="3_w"></el-option>
            <el-option label="集团品控工单" value="6"></el-option>  
          </el-select>
        </el-col>
        <el-col :span="4" v-if="activeName == 'abnormalWork'">
          异常类型：
          <el-select v-model="search.abnormal_type" placeholder="请选择异常类型" clearable size="mini"
                     @change="searchData">
            <el-option v-for="item in abnormalDataType" :key="item.index" :label="item.label" :value="item.index"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          选择日期：
          <el-date-picker
            v-model="search.dateArr[0]"
            type="date"
            @change="searchData"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
          至
          <el-date-picker
            v-model="search.dateArr[1]"
            type="date"
            @change="searchData"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button v-show="showButton" size="mini" style="color: #FFFFFF" type="primary" @click="exportGather()">导出绩效报表</el-button>
        </el-col>
        <el-col :span="4" v-if="activeName == 'abnormalWork'">
          <el-button size="mini" style="color: #FFFFFF" type="primary" @click="exportReportAbnormal()">导出明细</el-button>
          <el-button size="mini" style="color: #FFFFFF" type="primary" @click="exportReportAbnormalSummary()">导出汇总</el-button>
        </el-col>
      </el-row>

    </div>
    <v-divider></v-divider>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-left: 20px">
      <el-tab-pane label="数据总览" name="first">
        <div class="tab-scroll-content">

        <div class="body" v-show="gatherBox">
          <div class="visit2" v-loading="reportRepairGatherDayLoading">
            <div class="visit-title">{{ chart_title1 }}</div>
            <div class="visit-chart2" id="reportRepairGatherDay"></div>
          </div>
          <div class="visit2" v-loading="reportRepairGatherMonthLoading">
            <div class="visit-title">{{ chart_title2 }}</div>
            <div class="visit-chart2" id="reportRepairGatherMonth"></div>
          </div>
          <div class="visit2" v-loading="reportRepairGatherLoading">
            <div class="visit-title">{{ chart_title3 }}</div>
            <div class="visit-chart2" id="reportRepairGather"></div>
          </div>
          <div class="visit2" v-loading="warningLevelGatherLoading">
            <div class="visit-title">预警等级情况分析</div>
            <div class="visit-chart2" id="warningLevelGather"></div>
          </div>
          <!--          <div class="visit2" v-loading="complaintReportGatherLoading" v-show="complaintReportGatherBox">-->
          <!--            <div class="visit-title" >投诉情况</div>-->
          <!--            <div class="visit-chart2" id="complaintReportGather"></div>-->
          <!--          </div>-->

          <div style="display:flex;">
            <div class="visit1" style="flex: 1" v-loading="alertCategoryGatherLoading">
              <div class="visit-title">工单类型占比</div>
              <div class="visit-chart1" id="alertCategoryGather"></div>
            </div>
            <div class="visit1" style="flex: 1" v-loading="workOrderUncompletedGatherLoading">
              <div class="visit-title" v-show="workOrderUncompletedGatherBox">{{ chart_title4 }}</div>
              <div class="visit-chart1" id="workOrderUncompletedGather" v-show="workOrderUncompletedGatherBox"></div>
            </div>
          </div>
        </div>

        <div class="body" v-show="gather400Box">
          <div class="visit2" >
            <div class="visit-title">品控中心工单完成率</div>
            <div class="visit-chart2" id="reportRepairGather400Gather"></div>
          </div>
          <div style="display:flex;" >
            <div class="visit1" style="flex: 1">
              <div class="visit-title">品控中心工单类型分布</div>
              <div class="visit-chart1" id="alertCategory400Gather"></div>
            </div>
            <div class="visit1" style="flex: 1">

            </div>
          </div>
        </div>

        <div class="body" v-show="gatherTouSu">
          <div class="visit2">
            <div class="visit-title" >业主投诉(天)</div>
            <div class="visit-chart2" id="complaintDay"></div>
          </div>
          <div class="visit2">
            <div class="visit-title">业主投诉预警(天)</div>
            <div class="visit-chart2" id="complaintWarningDay"></div>
          </div>
          <div class="visit2">
            <div class="visit-title">业主投诉(月)</div>
            <div class="visit-chart2" id="complaintMonth"></div>
          </div>
          <div class="visit2">
            <div class="visit-title">业主投诉(前十排名)</div>
            <div class="visit-chart2" id="complaintRanking"></div>
          </div>

          <div style="display:flex;">
            <div class="visit1" style="flex: 1">
              <div class="visit-title">投诉类型分布</div>
              <div class="visit-chart1" id="complaintType"></div>
            </div>
            <div class="visit1" style="flex: 1">

            </div>
          </div>
        </div>

        </div>

      </el-tab-pane>
      <el-tab-pane label="数据列表" name="second">
        <div class="tab-scroll-content">
        <el-table :data="dataList" v-loading="loading" stripe height="500" style="width: 100%">
          <el-table-column prop="services_id" label="编号"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="tel" label="电话"></el-table-column>
          <el-table-column prop="house_name" label="项目"></el-table-column>
          <el-table-column prop="address" label="位置"></el-table-column>
          <el-table-column prop="content" label="报修内容" width="200" show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <template v-if="scope.row.site == 1">
                公区维修
              </template>
              <template v-if="scope.row.site == 2">
                居家报修
              </template>
              <template v-if="scope.row.site == 4">
                公区卫生
              </template>
              <template v-if="scope.row.site == 8">
                公区安全
              </template>
              <template v-if="scope.row.site == 16">
                公区绿化
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="member_type_text" label="工单来源"></el-table-column>
          <el-table-column prop="is_timeout_text" label="预警"></el-table-column>
          <el-table-column prop="status_text" label="状态"></el-table-column>
          <el-table-column prop="customer_evaluation" label="业主原话"></el-table-column>
          <el-table-column prop="evaluate" label="业主评价"></el-table-column>
          <el-table-column prop="created_at_text" label="提交时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button style="color: #FFFFFF" type="primary" size="mini" @click="getDetail(scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <v-divider></v-divider>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="search.total*1" :page-size="search.page_size*1"
                         :current-page="search.page_num*1" @current-change="pageChange"></el-pagination>
        </div>
        <!-- <repairs-detail ref="RepairsDetail"/> -->
        </div>
      </el-tab-pane>
      <el-tab-pane label="绩效报表" name="four">
        <div class="tab-scroll-content">
        <el-table :data="tableData" style="width: 100%;"  height="500" class='tableBox'
                  :summary-method="getSummaries"
                  show-summary>
          <el-table-column fixed prop="name" label="项目/区域" width="150" align="center">
            <template slot-scope="scope">
              <span v-show="totalTitle === '物业小计'">{{scope.row.zq_region_name}}</span>
              <span v-show="totalTitle == '战区小计'">{{scope.row.project_name}}</span>
              <span v-show="totalTitle == '项目小计'">{{scope.row.area_name}}</span>
              <span v-show="totalTitle == '区域小计'">{{scope.row.area_name}}</span>
              <!--              <el-button v-show="is400 == false" style="color: #FFFFFF" type="primary" size="mini" @click="getDetail(scope.row)">查看</el-button>-->
            </template>
          </el-table-column>
          <el-table-column label="绩效数据" align="center">
            <el-table-column prop="sys_plan_count" label="基准值" width="120" align="center"></el-table-column>
            <el-table-column prop="owner_repair_count" label="目标值" width="120" align="center"></el-table-column>
            <el-table-column prop="t_plan_count" label="实际下单数" width="120" align="center"></el-table-column>
            <el-table-column prop="kpi_count_score" label="下单数得分" width="120" align="center">
              <template slot-scope="scope">
                <template v-if="totalTitle == '项目小计' || totalTitle == '区域小计'">{{ scope.row.kpi_count_score }}</template>
                <template v-else>
                  -
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="completion_rate" label="优良率" width="120" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="公共安全事务" align="center">
            <el-table-column prop="a_plan_count" label="工单数" width="120" align="center"></el-table-column>
            <el-table-column prop="a_actual_count" label="已完成" width="120" align="center"></el-table-column>
            <el-table-column prop="a_percent" label="完成率(%)" width="120" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.a_percent == null">0.00</template>
                <template v-else>
                  {{scope.row.a_percent}}
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="日清日毕（公共卫生/绿化）" align="center">
            <el-table-column prop="s_plan_count" label="工单数" width="120" align="center"></el-table-column>
            <el-table-column prop="s_actual_count" label="已完成" width="120" align="center"></el-table-column>
            <el-table-column prop="s_percent" label="完成率(%)" width="120" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.s_percent == null">0.00</template>
                <template v-else>
                  {{scope.row.s_percent}}
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="报修事务（居家+公区维修）" align="center">
            <el-table-column prop="w_plan_count" label="工单数" width="120" align="center"></el-table-column>
            <el-table-column prop="w_actual_count" label="已完成" width="120" align="center"></el-table-column>
            <el-table-column prop="w_percent" label="完成率(%)" width="120" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.w_percent == null">0.00</template>
                <template v-else>
                  {{scope.row.w_percent}}
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="报事报修合计" align="center">
            <el-table-column prop="b_plan_count" label="工单数" width="120" align="center"></el-table-column>
            <el-table-column prop="b_actual_count" label="已完成" width="120" align="center"></el-table-column>
            <el-table-column prop="b_fine_count" label="优良数" width="120" align="center"></el-table-column>
            <el-table-column prop="b_percent" label="完成率(%)" width="120" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.b_percent == null">0.00</template>
                <template v-else>
                  {{scope.row.b_percent}}
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="b_fine_rate" label="优良率(%)" width="120" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="投诉事务" align="center">
            <el-table-column prop="c_plan_count" label="工单数" width="120" align="center"></el-table-column>
            <el-table-column prop="c_actual_count" label="已完成" width="120" align="center"></el-table-column>
            <el-table-column prop="c_fine_count" label="优良数" width="120" align="center"></el-table-column>
            <el-table-column prop="c_percent" label="完成率(%)" width="120" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.c_percent == null">0.00</template>
                <template v-else>
                  {{scope.row.c_percent}}
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="c_fine_rate" label="优良率(%)" width="120" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="报事报修+投诉合计" align="center">
            <el-table-column prop="t_plan_count" label="工单数" width="120" align="center"></el-table-column>
            <el-table-column prop="t_actual_count" label="已完成" width="120" align="center"></el-table-column>
            <el-table-column prop="t_percent" label="完成率(%)" width="120" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.t_percent == null">0.00</template>
                <template v-else>
                  {{scope.row.t_percent}}
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="visit_rate" label="回访率(%)" width="120" align="center"></el-table-column>
        </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="业主工单" name="five">
        <div class="tab-scroll-content">
        <el-table :data="ownerWorkOrderData" v-loading="ownerWorkOrderLoading" style="width: 100%;" height="500" class='tableBox'>
          <el-table-column prop="project_name" label="项目名称" width="150" align="center"></el-table-column>
          <el-table-column prop="nickname" label="微信昵称" width="120" align="center"></el-table-column>
          <el-table-column prop="phone" label="微信电话" width="120" align="center"></el-table-column>
          <el-table-column prop="area_name" label="区域名称" width="120" align="center"></el-table-column>
          <el-table-column prop="A" label="公区维修" width="100" align="center"></el-table-column>
          <el-table-column prop="B" label="个人维修" width="100" align="center"></el-table-column>
          <el-table-column prop="C" label="公区卫生" width="100" align="center"></el-table-column>
          <el-table-column prop="D" label="公区安全" width="100" align="center"></el-table-column>
          <el-table-column prop="E" label="公区绿化" width="100" align="center"></el-table-column>
          <el-table-column prop="F" label="服务态度" width="100" align="center"></el-table-column>
          <el-table-column prop="G" label="公区维修(投诉)" width="120" align="center"></el-table-column>
          <el-table-column prop="H" label="公区卫生绿化(投诉)" width="150" align="center"></el-table-column>
          <el-table-column prop="I" label="公区安全(投诉)" width="120" align="center"></el-table-column>
          <el-table-column prop="J" label="报事报修合计" width="120" align="center"></el-table-column>
          <el-table-column prop="K" label="投诉建议合计" width="120" align="center"></el-table-column>
          <el-table-column prop="count" label="总合计" width="100" align="center"></el-table-column>
        </el-table>
        <div class="pagination-wrap" v-if="ownerWorkOrderData.length > 0">
          <el-pagination 
            background 
            layout="prev, pager, next" 
            :total="ownerWorkOrderTotal"
            :page-size="ownerWorkOrderPageSize"
            :current-page="ownerWorkOrderCurrentPage"
            @current-change="ownerWorkOrderPageChange"
          ></el-pagination>
        </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="异常工单" name="abnormalWork">
        <div class="tab-scroll-content">
        <el-table :data="abnormalDataList" v-loading="loading" stripe height="500" style="width: 100%">
          <el-table-column prop="services_id" label="编号"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="tel" label="电话"></el-table-column>
          <el-table-column prop="house_name" label="项目"></el-table-column>
          <el-table-column prop="address" label="位置"></el-table-column>
          <el-table-column prop="content" label="报修内容" width="200" show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <template v-if="scope.row.site == 1">
                公区维修
              </template>
              <template v-if="scope.row.site == 2">
                居家报修
              </template>
              <template v-if="scope.row.site == 4">
                公区卫生
              </template>
              <template v-if="scope.row.site == 8">
                公区安全
              </template>
              <template v-if="scope.row.site == 16">
                公区绿化
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="member_type_text" label="工单来源"></el-table-column>
          <el-table-column prop="is_timeout_text" label="预警"></el-table-column>
          <el-table-column prop="abnormal_type_text" label="异常类型"></el-table-column>
          <el-table-column prop="status_text" label="状态"></el-table-column>
          <el-table-column prop="customer_evaluation" label="业主原话"></el-table-column>
          <el-table-column prop="evaluate" label="业主评价"></el-table-column>
          <el-table-column prop="created_at_text" label="提交时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button style="color: #FFFFFF" type="primary" size="mini" @click="getDetail(scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <v-divider></v-divider>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="search.total*1" :page-size="search.page_size*1"
                         :current-page="search.page_num*1" @current-change="pageChange" v-if="activeName != 'abnormalWork'"></el-pagination>
          <el-pagination background layout="prev, pager, next" :total="search.abnormal_total*1" :page-size="search.abnormal_page_size*1"
                         :current-page="search.abnormal_page_num*1" @current-change="pageChange" v-else></el-pagination>
        </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <repairs-detail ref="RepairsDetail"/>
  </div>
</template>

<script>
import _ from "lodash";
import RepairsDetail from "./RepairsDetail";
import Http from "../../Oa/common/OaHttp";
import UserProjectInfo from "../../Butler/common/UserProjectInfo";
import * as echarts from "echarts";
import 'echarts-wordcloud';
import SelectCdjProjectHeader from"../../Butler/components/common/SelectCdjProjectHeader"


const statusArr = ['待受理','处理中', '待回访', '待评价', '已完成', '暂挂', '无效工单'];
export default {
  name: 'Repairs',
  components: {RepairsDetail, SelectCdjProjectHeader},
  data() {
    return {
      tableData: [],
      tableAllData: [],
      totalTitle: '物业小计',
      activeName: 'first',
      // 业主工单数据
      ownerWorkOrderData: [],
      ownerWorkOrderLoading: false,
      ownerWorkOrderDateRange: [],
      ownerWorkOrderTotal: 0,
      ownerWorkOrderPageSize: 20,
      ownerWorkOrderCurrentPage: 1,
      isIndeterminate: false,
      status_total: {
        'status_0': 0,
        'status_2': 0,
        'status_7': 0,
        'status_3': 0,
        'status_3000': 0,
        'status_5': 0,
        'status_4': 0,
        'total': 0
      },
      abnormal_status_total: {
        'status_0': 0,
        'status_2': 0,
        'status_7': 0,
        'status_3': 0,
        'status_3000': 0,
        'status_5': 0,
        'status_4': 0,
        'total': 0
      },
      loading: false,
      showButton: false,
      site_list: [
        {value : 1, name: '公区维修'},
        {value : 2, name: '居家报修'},
        {value : 20, name: '日清日毕'},
        {value : 8, name: '公区安全'},
        {value : 888, name: '业主线上投诉单'},
      ],
      repair_type_list: [
        {value : 1, name: '公区维修'},
        {value : 2, name: '居家报修'},
        {value : 20, name: '日清日毕'},
        {value : 8, name: '公区安全'},
        {value : 888, name: '业主线上投诉单'},
      ],
      repair_type_list400: [
        {value: 1, name: '鹰眼违规'},
        {value: 2, name: '代办抽查'},
        {value: 4, name: '400投诉扭转工单'},
        // {value: 8, name: '业主端三级预警工单'},
        {value: 16, name: '48小时未处理'},
        {value: 32, name: '处理结果不满意'},
        {value: 64, name: '鹰眼设备异常工单'},
        {value: 128, name: '舆情工单'},
      ],
      search: {
        dateArr: [],
        statusList: statusArr,
        select_status: [],
        services_id: '',
        site: '',
        is_timeout: '',
        region: '',
        region_list: [],
        project: '',
        project_list: [],
        page_size: 20,
        page_num: 1,
        total: 0,
        start_date: '',
        end_date: '',
        member_type: "2",
        report_type: 'repair',
        checkAll: false,
        area: '',
        area_list: '',
        project_ids: '',
        type_id: '',
        type_list: [],
        place_list:[],
        place_id:'',
        abnormal_page_size: 20,
        abnormal_page_num: 1,
        abnormal_total: 0,
      },
      dataList: [],
      abnormalDataList: [],
      projectRegion: [],
      projectList: [],
      areaList: [],
      regionListKeyById: {},
      reportRepairGatherDayLoading: true,
      reportRepairGatherMonthLoading: true,
      reportRepairGatherLoading: true,
      warningLevelGatherLoading: true,
      workOrderUncompletedGatherLoading: true,
      alertCategoryGatherLoading: true,
      complaintReportGatherLoading: true,
      chart_title1: "物业端完成率（天）",
      chart_title2: "物业端完成率（月）",
      chart_title3: "物业端完成率（年）",
      chart_title4: "",
      complaintReportGatherBox: true,
      workOrderUncompletedGatherBox: true,
      gather400Box: true,
      gatherTouSu: false,
      gatherBox: true,
      editStatusTotal: false,
      setDisabled: false,
      abnormalDataType: []
    }
  },
  //界面没出来前加载
  created() {

  },
  mounted() {
    this.search.dateArr = this.getNowTime();
    this.getReportAbnormalType()
  },
  activated() {

    // this.search.type_id = 1
    // let that = this
    // UserProjectInfo.ready(function () {
    //   that.search.type_list = UserProjectInfo.getTypeList();
    //   that.search.region_list = UserProjectInfo.getRegionList(that.search.type_id);
    // }, 1)
    // that.searchData()
  },
  computed: {},
  watch: {
    'search.member_type': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.search.site = ''
      }
      if (newValue == 6) {
        this.site_list =  this.repair_type_list400
        this.search.area = ''
        this.setDisabled = true
      } else {
        this.site_list =  this.repair_type_list
        this.setDisabled = false
      }
      this.searchData()
    },
    'search.site': function (newValue) {
      this.searchData()
    },
    'search.dateArr': function (newValue) {
      this.getOwnerWorkOrderData()
      this.searchData()
    },
    'search': function (newValue) {
      this.searchData()
    },
    'search.project_ids': function (newValue) {
      this.getOwnerWorkOrderData()
    },
    'search.project': function (newValue) {
      this.getOwnerWorkOrderData()
    },
  },
  //事件
  methods: {
    onHeader(data){
      const that=this;
      that.search.type_id=data.type_id;
      that.search.type_list=data.type_list;
      that.search.region=data.project_region;
      that.search.region_list=data.project_region_list;
      that.search.project_region_level=data.project_region_level;
      that.search.project=data.project_name;
      that.search.project_list=data.project_list;
      that.search.group_by=data.group_by;
      that.search.area=data.area_id;
      that.search.area_list=data.area_list;
      that.search.project_ids=data.project_ids;
      that.search.level=data.level;
      that.is_loading=true;

      if (that.search.project) {
        that.search.project_ids =that.search.project;
      }
      this.searchData()
    },
    handleCheckAllChange(val) {
      this.search.select_status = val ? statusArr : [];
      this.isIndeterminate = false;
      this.searchData("handleCheck")
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.search.checkAll = checkedCount === this.search.statusList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.search.statusList.length;
      this.searchData("handleCheck")
    },
    searchData(type = 'all') {
      this.editStatusTotal = false
      this.totalTitle = '物业小计'
      if (this.search.region > 0) {
        this.totalTitle = '战区小计'
      }
      if (this.search.project > 0) {
        this.totalTitle = '项目小计'
      }
      if (this.search.area > 0) {
        this.totalTitle = '区域小计'
      }
      if (type != "handleCheck") {
        this.editStatusTotal = true
      }
      this.search.page_num = 1
      this.search.abnormal_page_num = 1
      this.getRepairList()
      this.getRepairAchievements()
      this.getRepairAchievementsTotal()
      this.getRepairAbnormalList()
      if (this.activeName == 'first' && type == 'all') {
        this.createChart()
      }
    },
    pageChange(i) {
      if(this.activeName != 'abnormalWork') {
        this.search.page_num = i
        this.getRepairList()
      }else {
        this.search.abnormal_page_num = i
        this.getRepairAbnormalList()
      }
    },
    getRepairList() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      if (this.search.project_ids == '') {
        // let projectIds = [];
        // for (const k in this.search.region_list) {
        //   let item = this.search.region_list[k]
        //   let list = this.getProjectListByRegion(item.id)
        //   projectIds.push(list.map(item => item.erp_pindex_id))
        // }
        // this.search.project_ids = projectIds.join(',');
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.loading = true
      this.$myhttp.post('admin/getReportForRepair', this.search, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];

        if (resData.code == 200) {
          this.dataList = resData.list
          this.search.total = resData.total
          if (this.editStatusTotal) {
            // 统计各个状态数量
            this.status_total = resData.status_total[0]
            if (this.status_total.status_0 == null) {
              this.status_total.status_0 = 0
            }
            if (this.status_total.status_2 == null) {
              this.status_total.status_2 = 0
            }
            if (this.status_total.status_7 == null) {
              this.status_total.status_7 = 0
            }
            if (this.status_total.status_3 == null) {
              this.status_total.status_3 = 0
            }
            if (this.status_total.status_3000 == null) {
              this.status_total.status_3000 = 0
            }
            if (this.status_total.status_5 == null) {
              this.status_total.status_5 = 0
            }
            if (this.status_total.status_4 == null) {
              this.status_total.status_4 = 0
            }
          }
        }
      });
    },
    getRepairAbnormalList() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      if (this.search.project_ids == '') {
        // let projectIds = [];
        // for (const k in this.search.region_list) {
        //   let item = this.search.region_list[k]
        //   let list = this.getProjectListByRegion(item.id)
        //   projectIds.push(list.map(item => item.erp_pindex_id))
        // }
        // this.search.project_ids = projectIds.join(',');
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.loading = true
      this.$myhttp.post('admin/getReportAbnormal', this.search, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];

        if (resData.code == 200) {
          this.abnormalDataList = resData.list
          this.search.abnormal_total = resData.total
          if (this.editStatusTotal) {
            // 统计各个状态数量
            this.abnormal_status_total = resData.status_total[0]
            if (this.abnormal_status_total.status_0 == null) {
              this.abnormal_status_total.status_0 = 0
            }
            if (this.abnormal_status_total.status_2 == null) {
              this.abnormal_status_total.status_2 = 0
            }
            if (this.abnormal_status_total.status_7 == null) {
              this.abnormal_status_total.status_7 = 0
            }
            if (this.abnormal_status_total.status_3 == null) {
              this.abnormal_status_total.status_3 = 0
            }
            if (this.abnormal_status_total.status_3000 == null) {
              this.abnormal_status_total.status_3000 = 0
            }
            if (this.abnormal_status_total.status_5 == null) {
              this.abnormal_status_total.status_5 = 0
            }
            if (this.abnormal_status_total.status_4 == null) {
              this.abnormal_status_total.status_4 = 0
            }
          }
        }
      });
    },
    getRegionList() {
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/User/getUserProjectInfo", {'status': 0}, res => {
        if (res.code == 0) {
          that.projectRegion = this.getRegionTree(0, res.data.region_list)
          that.projectList = res.data.project_list
          that.areaList = res.data.area_list

          for (const k in res.data.region_list) {
            this.regionListKeyById[res.data.region_list[k]['id']] = res.data.region_list[k];
          }

          that.search.region_list = this.getRegionTree(0, res.data.region_list)
          this.getRepairList()
        }
      });
    },
    // 战区列表转为树结构
    getRegionTree(id, d) {
      let list = []
      for (const k in d) {
        if (d[k].pid == id) {
          let item = d[k]
          item.children = this.getRegionTree(item.id, d)
          list.push(item)
        }
      }
      return list
    },
    selectRegion() {
      this.search.project = '';
      this.search.area = '';
      // this.search.project_list = this.getProjectListByRegion(this.search.region);
      // this.search.project_ids = this.getProjectIds(this.search);
      this.searchData();
    },
    selectProject() {
      this.search.area = '';
      this.search.area_list = this.getAreaList(this.search.project);
      this.searchData();
    },
    getDetail(item) {
      console.info(item)
      this.$refs.RepairsDetail.show(item.id)
    },
    getNowTime() {
      // let start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
      //     .toISOString()
      //     .replace('T', ' ')
      //     .split('.')[0] //默认开始时间7天前

      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      month = month + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let start = year + '-' + month + '-01';

      let end = new Date(new Date().getTime())
        .toISOString()
        .replace('T', ' ')
        .split('.')[0]//默认结束时间

      // start = start.substring(0,10)
      end = end.substring(0, 10)
      return [start, end]
    },
    // 获取战区项目列表
    getProjectListByRegion(projectRegionId) {
      if (projectRegionId) {
        const regionItem = this.getRegion(projectRegionId)
        return this.projectList.filter(item => regionItem.pindex_ids.includes(item.erp_pindex_id + ''))
      } else {
        return this.projectList
      }
    },

    // 获取项目的区域
    getAreaList(projectId) {
      if (projectId) {
        const projectItem = this.getProject(projectId)
        return this.areaList.filter(item => item.erp_pindex_id == projectItem.erp_pindex_id)
      } else {
        return []
      }
    },

    getRegion(id) {
      // let projectRegion = this.projectRegion
      // for (const k in projectRegion) {
      //   if (projectRegion[k].id == id) {
      //     return projectRegion[k]
      //   }
      // }
      return this.regionListKeyById[id];
    },

    getProject(id) {
      let projectList = this.projectList
      for (const k in projectList) {
        if (projectList[k].erp_pindex_id == id) {
          return projectList[k]
        }
      }
    },
    getProjectIds(data) {
      let project_id = '';
      if (data.project) {
        project_id = data.project
      } else {
        if (data.region) {
          const list = this.getProjectListByRegion(data.region)
          project_id = list.map(item => item.erp_pindex_id).join(',')
        } else {
          project_id = this.projectList.map(item => item.erp_pindex_id).join(',')
        }
      }
      return project_id;
    },
    // 新建图标
    createChart() {
      if (this.search.member_type != 1 && this.search.member_type != '1_8' && this.search.member_type != '1_w'  && this.search.member_type != '3_w' && this.search.member_type != '8_w') {
        // 物业完成率（天）
        this.reportRepairGatherDayChart("https://ckpt.51homemoney.com/api/MgtReportForm/reportRepairGatherByDay")
        // 物业完成率（月）
        this.reportRepairGatherMonthChart("https://ckpt.51homemoney.com/api/MgtReportForm/reportRepairGatherByDay")
        // 物业完成率（年）
        this.reportRepairGatherChart("https://ckpt.51homemoney.com/api/MgtReportForm/reportRepairGather")
        // 物业工单类型占比
        this.getAlertCategoryData("https://ckpt.51homemoney.com/api/MgtReportForm/alertCategory")
        // 物业工单未完成量前十名
        this.getWorkOrderUncompletedData("https://ckpt.51homemoney.com/api/MgtReportForm/workOrderUncompletedQuantity")
        // 物业预警等级情况分析
        this.getWarningLevelGatherData("https://ckpt.51homemoney.com/api/MgtReportForm/reportRepairGather")
      } else {
          // 业主端完成率（天）
          this.reportRepairGatherDayChart("https://ckpt.51homemoney.com/api/CustReportForm/reportRepairGatherOwnerByDay")
          // 业主端完成率（月）
          this.reportRepairGatherMonthChart("https://ckpt.51homemoney.com/api/CustReportForm/reportRepairGatherOwnerByDay")
          // 业主端完成率（年）
          this.reportRepairGatherChart("https://ckpt.51homemoney.com/api/CustReportForm/reportRepairGatherOwner", 'post')
          // 业主端工单类型占比
          this.getAlertCategoryData("https://ckpt.51homemoney.com/api/CustReportForm/alertCategory", 'post')
          // 业主端工单投诉量前十名
          this.getWorkOrderUncompletedData("https://ckpt.51homemoney.com/api/CustReportForm/complaintTop10", 'post')
          // 业主端预警等级情况分析
          this.getWarningLevelGatherData("https://ckpt.51homemoney.com/api/CustReportForm/warningLevel", 'post')
          this.workOrderUncompletedGatherBox = false
      }

      // 业主端投诉情况
      //this.getComplaintReportGatherData('https://ckpt.51homemoney.com/api/CustReportForm/complaintReport')
      // 集团400
      this.getReportRepairGather400Gather('https://ckpt.51homemoney.com/api/Mgt400ReportForm/reportRepairGather')
      this.getAlertCategory400Data("https://ckpt.51homemoney.com/api/Mgt400ReportForm/alertCategory")
      
      // 业主端投诉情况
      this.getComplaintDayChart();
      this.getComplaintWarningDayChart();
      this.getComplaintMonthChart();
      this.getComplaintRankingChart();
      this.getComplaintTypeChart();

      if (this.search.member_type == 2 || this.search.member_type == "") {
        this.chart_title1 = "物业端完成率（天）"
        this.chart_title2 = "物业端完成率（月）"
        this.chart_title3 = "物业端完成率（年）"
        this.chart_title4 = "工单未完成量前十名"
        this.complaintReportGatherBox = false
        this.gatherBox = true;
        this.gather400Box = false
        this.gatherTouSu = false
      }
      if (this.search.member_type == 1 || this.search.member_type == '1_w' || this.search.member_type == '3_w' || this.search.member_type == '8_w') {
        this.chart_title1 = "业主端情况（天）"
        this.chart_title2 = "业主端情况（月）"
        this.chart_title3 = "业主端情况（年）"
        this.chart_title4 = "工单投诉量前十名"
        this.complaintReportGatherBox = true
        this.gatherBox = true;
        this.gather400Box = false
        this.gatherTouSu = false
      }
      if (this.search.member_type == 6) {
        this.complaintReportGatherBox = true
        this.gatherBox = false;
        this.gather400Box = true
        this.gatherTouSu = false
      }
      if (this.search.member_type == '1_8') {
        this.gatherBox = false;
        this.gather400Box = false
        this.gatherTouSu = true
        // this.gatherBox = true;
        // this.gather400Box = false
        // this.gatherTouSu = false
      }
    },
    // 物业完成率（天）
    reportRepairGatherDayChart(url) {
      let that = this
      var chartDom = document.getElementById('reportRepairGatherDay');
      var myChart = echarts.init(chartDom);
      let params = {}
      let where = this.search
      // where.data_range = [this.search.start_date, this.search.end_date]
      // where.group_by = 'day'
      // where.area_name = where.area
      // where.repair_type = where.site
      params.data_range = [this.search.start_date, this.search.end_date]
      params.group_by = 'day'
      params.area_name = where.area
      params.repair_type = where.site
      params.project_ids = where.project_ids
      params.member_type = where.member_type
      Http.get(url,
        params,
        res => {
          that.reportRepairGatherDayLoading = false
          if (res.code) {
            let allPlanCount = 0;
            let allOrder = 0;
            for(let i in res.data) {
              allPlanCount = parseInt(res.data[i]["all_plan_count"])
              allOrder = allOrder +  parseInt(res.data[i]["all_work_order"])
            }
            let completeRate = ((allOrder / allPlanCount) * 100).toFixed(2)
            let title = ""
            if (params.member_type != '3_w' && params.member_type != '8_w') {
              title = "计划下单数: "+ allPlanCount +",实际下单数: "+allOrder+", 计划完成率: " + completeRate + "%"
            } else if (params.member_type == '3_w') {
              title = "代办工单下单数: "+allOrder
            } else if (params.member_type == '8_w') {
              title = "舆情工单下单数: "+allOrder
            }
            
            let option = this.reportRepairGatherDayOption(res.data, title)
            option && myChart.setOption(option);
            myChart.resize()
          }
        })
    },
    reportRepairGatherDayOption(data, title) {
      const name_list = ["工单数"];
      let color_list = ["#409eff"];
      let type = ["bar"];
      let yAxisIndex = [0];
      // 获取战区
      let xData = [];
      // 获取Y轴数据
      let yData = {
        '工单数': [],
        '完成率': [],
        '及时率': [],
        '优良率': [],
      };
      for (let key in data) {
        xData.push(data[key]['date_name']);
        yData['工单数'].push(data[key]['all_work_order']);
        yData['完成率'].push(data[key]['completion_rate']);
        yData['及时率'].push(data[key]['timeliness_rate']);
        yData['优良率'].push(data[key]['satisfaction_good_rate']);
      }
      let series_data = function () {
        return name_list.map((rt, index) => {
          return {
            "name": rt,
            "type": type[index],
            yAxisIndex: yAxisIndex[index],
            "color": color_list[index],
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            "data": yData[rt]
          }
        })
      }
      return {
        title:
          {
            left: 'center',
            text: title
          },
        "tooltip": {
          "trigger": "axis",
          formatter: function (params) {
            let date = params[0]['name'];
            let all_work_order = data[date]['all_work_order']
            let completion_rate = data[date]['completion_rate']
            let timeliness_rate = data[date]['timeliness_rate']
            let satisfaction_good_rate = data[date]['satisfaction_good_rate']

            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#3399ff"></span>';
            returnData += "工单数：" + all_work_order + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + completion_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#ffcc00"></span>';
            returnData += "及时率：" + timeliness_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#cc33ff"></span>';
            returnData += "优良率：" + satisfaction_good_rate + "%</br>";
            return returnData;
          }
        },
        "grid": {
          "borderWidth": 0,
          "top": 110,
          "bottom": 95,
          left: 50,
          right: 50,
          textStyle: {
            color: "#949494"
          }
        },
        "legend": {
          x: 'center',
          top: '8%',
          selected: {
            "工单数": true,
          },
          "data": name_list
        },
        "xAxis": [{
          "type": "category",
          // "axisLabel":{interval:0,rotate:45,margin:20},
          "data": xData,
        }],
        "yAxis": [{
          "type": "value",
          name: "工单数",
        }],
        "series": series_data()
      }
    },

    // 物业完成率（月）
    reportRepairGatherMonthChart(url) {
      let currentDate = new Date()
      let that = this
      let params = {}
      var chartDom = document.getElementById('reportRepairGatherMonth');
      var myChart = echarts.init(chartDom);
      let where = this.search
      let date = this.search.start_date.split("-")
      if (date != null) {
        params.year = date[0]
        params.month = date[0]
      } else {
        params.year = currentDate.getFullYear();
        params.month = date.getMonth() + 1;
      }
      // where.data_range = [this.search.start_date, this.search.end_date]
      // where.group_by = 'month'
      // where.area_name = where.area
      // where.repair_type = where.site

      params.data_range = [this.search.start_date, this.search.end_date]
      params.group_by = 'month'
      params.area_name = where.area
      params.repair_type = where.site
      params.project_ids = where.project_ids
      params.member_type = where.member_type
      Http.get(url,
        params,
        res => {
          that.reportRepairGatherMonthLoading = false
          if (res.code) {
            let allPlanCount = 0;
            let allOrder = 0;
            for(let i in res.data) {
              allPlanCount = parseInt(res.data[i]["all_plan_count"])
              allOrder = allOrder +  parseInt(res.data[i]["all_work_order"])
            }
            let completeRate = ((allOrder / allPlanCount) * 100).toFixed(2)
            let title = ""
            let option = this.reportRepairGatherMonthOption(res.data, title)
            // 清除旧图表数据后重新渲染
            myChart.clear();
            option && myChart.setOption(option, true);
            myChart.resize()
          }
        })
    },
    reportRepairGatherMonthOption(data, title) {
      const hidePlanTarget = ['1_8', '3_w', '8_w'].includes(this.search.member_type);
      const name_list = hidePlanTarget ? ["工单数"] : ["计划目标", "工单数"];
      const color_list = hidePlanTarget ? ["rgba(204,152,54,0.9)"] : ["#409eff", "rgba(204,152,54,0.9)"];
      const type = hidePlanTarget ? ['bar'] : ["bar", 'bar'];
      const yAxisIndex = hidePlanTarget ? [0] : [0, 0];
      console.info(name_list)
      // 获取战区
      let xData = [];
      // 获取Y轴数据
      let yData = {
        '工单数': [],
        '计划目标': [],
        '完成率': [],
        '及时率': [],
        '优良率': [],
        '计划完成率': [],
      };
      for (let key in data) {
        xData.push(data[key]['month'] + '月');
        yData['工单数'].push(data[key]['all_work_order']);
        yData['计划目标'].push(data[key]['total_plan_count']);
        yData['完成率'].push(data[key]['completion_rate']);
        yData['及时率'].push(data[key]['timeliness_rate']);
        yData['优良率'].push(data[key]['satisfaction_good_rate']);
        yData['计划完成率'].push(data[key]['plan_count_rate']);
      }
      let series_data = function () {
        return name_list.map((rt, index) => {
          return {
            "name": rt,
            "type": type[index],
            yAxisIndex: yAxisIndex[index],
            "color": color_list[index],
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            "data": yData[rt]
          }
        })
      }
      return {
        "tooltip": {
          "trigger": "axis",
          formatter: function (params) {
            let date = params[0]['axisValue'];
            date = date.slice(0, -1)
            let all_work_order = data[date]['all_work_order']
            let total_plan_count = data[date]['total_plan_count']
            let completion_rate = data[date]['completion_rate']
            let timeliness_rate = data[date]['timeliness_rate']
            let satisfaction_good_rate = data[date]['satisfaction_good_rate']
            let plan_count_rate = data[date]['plan_count_rate']

            let returnData = "";
            if (!hidePlanTarget) {
              returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#409eff"></span>';
              returnData += "计划目标：" + total_plan_count + "</br>";
            }
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:rgba(204,152,54,0.9)"></span>';
            returnData += "工单数：" + all_work_order + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + completion_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#ffcc00"></span>';
            returnData += "及时率：" + timeliness_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#cc33ff"></span>';
            returnData += "优良率：" + satisfaction_good_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00ff80"></span>';
            returnData += "计划完成率：" + plan_count_rate + "%</br>";
            return returnData;
          }
        },
        "grid": {
          "borderWidth": 0,
          "top": 110,
          "bottom": 95,
          left: 50,
          right: 50,
          textStyle: {
            color: "#949494"
          }
        },
        "legend": {
          x: 'center',
          top: '8%',
          selected: {
            "工单数": true,
            "计划目标数": true,
          },
          "data": name_list
        },


        "calculable": true,
        "xAxis": [{
          "type": "category",
          "axisLine": {
            lineStyle: {
              color: '#90979c'
            }
          },
          "axisLabel":{interval:0,rotate:45,margin:20},
          "data": xData,
        }],

        "yAxis": [{
          "type": "value",
          "splitLine": {
            "show": true
          },
          "axisLine": {
            lineStyle: {
              color: '#90979c'
            }
          },
          "axisTick": {
            "show": true
          },
          "axisLabel": {
            "interval": 0,
          },
          "splitArea": {
            "show": false
          },
          name: "工单数",

        }, {
          "type": "value",
          "splitLine": {
            "show": true
          },
          "axisLine": {
            lineStyle: {
              color: '#90979c'
            }
          },
          name: "完成率",

        }],
        "series": series_data()
      }
    },

    // 物业完成率（年）
    reportRepairGatherChart(url, httpType = 'get') {
      let currentDate = new Date()
      let that = this
      var chartDom = document.getElementById('reportRepairGather');
      var myChart = echarts.init(chartDom);
      let where = this.search
      let params = {}
      let date = this.search.start_date.split("-")
      if (date != null) {
        params.year = date[0]
        params.month = date[1]
      } else {
        params.year = currentDate.getFullYear();
        params.month = date.getMonth() + 1;
      }
      // where.data_range = [where.year + '-01-01', where.year + '-12-31']
      // where.area_name = where.area
      // where.repair_type = where.site

      params.data_range = [params.year + '-01-01',params.year + '-12-31']
      params.area_name = where.area
      params.repair_type = where.site
      params.project_ids = where.project_ids
      params.member_type = where.member_type
      // 判断group
      if (this.search.region != '') {
        params.group_by = 'project'
      }
      if (this.search.project != '') {
        params.group_by = 'area'
      }

      if (httpType == 'get') {
        Http.get(url,
          params,
          res => {
            that.reportRepairGatherLoading = false
            if (res.code) {
              let option = this.reportRepairGatherOption(res.data, "")
              // 清除旧图表数据后重新渲染
              myChart.clear();
              option && myChart.setOption(option, true);
              myChart.resize()
            }
          })
      } else {
        Http.post(url,
          params,
          res => {
            that.reportRepairGatherLoading = false
            if (res.code) {
              let option = this.reportRepairGatherOption(res.data, "")
              // 清除旧图表数据后重新渲染
              myChart.clear();
              option && myChart.setOption(option, true);
              myChart.resize()
            }
          })
      }

    },
    reportRepairGatherOption(data, title) {
      const hidePlanTarget = ['1_8', '3_w', '8_w'].includes(this.search.member_type);
      const name_list = hidePlanTarget ? ["工单数"] : ["计划目标", "工单数"];
      const color_list = hidePlanTarget ? ["rgba(204,152,54,0.9)"] : ["#409eff", "rgba(204,152,54,0.9)"];
      const type = hidePlanTarget ? ['bar'] : ["bar", 'bar'];
      const yAxisIndex = hidePlanTarget ? [0] : [0, 0];
      // 获取战区
      let xData = [];
      // 获取Y轴数据
      let yData = {
        '工单数': [],
        '计划目标': [],
        '完成率': [],
        '及时率': [],
        '优良率': [],
        '计划完成率': [],
      };
      for (let key in data) {
        xData.push(key);
        yData['工单数'].push(data[key]['all_work_order']);
        yData['计划目标'].push(data[key]['total_plan_count']);
        yData['完成率'].push(data[key]['completion_rate']);
        yData['及时率'].push(data[key]['timeliness_rate']);
        yData['优良率'].push(data[key]['satisfaction_good_rate']);
        yData['计划完成率'].push(data[key]['plan_count_rate']);
      }
      let series_data = function () {
        return name_list.map((rt, index) => {
          return {
            "name": rt,
            "type": type[index],
            yAxisIndex: yAxisIndex[index],
            "color": color_list[index],
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            "data": yData[rt]
          }
        })
      }
      return {
        "tooltip": {
          "trigger": "axis",
          formatter: function (params) {
            let key = params[0]['axisValue']
            let all_work_order = data[key]['all_work_order']
            let total_plan_count = data[key]['total_plan_count']
            let completion_rate = data[key]['completion_rate']
            let timeliness_rate = data[key]['timeliness_rate']
            let satisfaction_good_rate = data[key]['satisfaction_good_rate']
            let plan_count_rate = data[key]['plan_count_rate']

            let returnData = "";
            if (!hidePlanTarget) {
              returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#409eff"></span>';
              returnData += "计划目标：" + total_plan_count + "</br>";
            }
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:rgba(204,152,54,0.9)"></span>';
            returnData += "工单数：" + all_work_order + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + completion_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#ffcc00"></span>';
            returnData += "及时率：" + timeliness_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#cc33ff"></span>';
            returnData += "优良率：" + satisfaction_good_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00ff80"></span>';
            returnData += "计划完成率：" + plan_count_rate + "%</br>";
            return returnData;
          }
        },
        "grid": {
          "borderWidth": 0,
          "top": 110,
          "bottom": 95,
          left: 50,
          right: 50,
          textStyle: {
            color: "#949494"
          }
        },
        "legend": {
          x: 'center',
          top: '8%',
          selected: {
            "工单数": true,
            "计划目标数": true,
          },
          "data": name_list
        },
        "xAxis": [{
          "type": "category",
          "axisLabel":{interval:0,rotate:45,margin:20},
          "data": xData,
        }],
        "yAxis": [{
          "type": "value",
          name: "工单数",

        }, {
          "type": "value",
          name: "完成率",

        }],
        "series": series_data()
      }
    },

    // 获取预警等级情况分析数据
    getWarningLevelGatherData(url, httpType = 'get') {
      let currentDate = new Date()
      let that = this
      var chartDom = document.getElementById('warningLevelGather');
      var myChart = echarts.init(chartDom);
      let where = this.search
      let date = this.search.start_date.split("-")
      let params = {}
      if (date != null) {
        params.year = date[0]
        params.month = date[0]
      } else {
        params.year = currentDate.getFullYear();
        params.month = date.getMonth() + 1;
      }
      // where.data_range = [this.search.start_date, this.search.end_date]
      // where.area_name = where.area
      // where.repair_type = where.site
      params.data_range = [this.search.start_date,this.search.end_date]
      params.area_name = where.area
      params.repair_type = where.site
      params.project_ids = where.project_ids
      params.group_by = ''
      params.member_type = where.member_type

      // 判断group
      if (this.search.region != '') {
        params.group_by = 'project'
      }
      if (this.search.project != '') {
        params.group_by = 'area'
      }
      if (httpType == 'get') {
        Http.get(url,
          params,
          res => {
            that.warningLevelGatherLoading = false
            if (res.code) {
              let option = this.warningLevelGatherOption(res.data)
              option && myChart.setOption(option);
              myChart.resize()
            }
          })
      } else {
        Http.post(url,
          params,
          res => {
            that.warningLevelGatherLoading = false
            if (res.code) {
              let option = this.warningLevelGatherOption(res.data)
              option && myChart.setOption(option);
              myChart.resize()
            }
          })
      }

    },
    warningLevelGatherOption(data) {
      let name_list = ["一级", "二级", "三级"];
      let color_list = ["#409eff", "#e6a23c", "#f56c6c"];
      let xData = [];
      // 获取Y轴数据
      let yData = {
        '一级': [],
        '二级': [],
        '三级': [],
      };
      for (let key in data) {
        xData.push(data[key]['name']);
        yData['一级'].push(data[key]['d1']);
        yData['二级'].push(data[key]['d2']);
        yData['三级'].push(data[key]['d3']);
      }
      let series_data = function () {
        return name_list.map((rt, index) => {
          return {
            "name": rt,
            "type": "bar",
            "color": color_list[index],
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            "data": yData[rt]
          }
        })
      }
      return {
        "tooltip": {
          "trigger": "axis",
        },
        "grid": {
          "borderWidth": 0,
          "top": 110,
          "bottom": 95,
          left: 50,
          right: 50,
          textStyle: {
            color: "#949494"
          }
        },
        "legend": {
          x: 'center',
          top: '8%',
          selected: {
            "工单数": true,
            "计划目标数": true,
          },
          "data": name_list
        },
        "xAxis": [{
          "type": "category",
          "data": xData,
          "axisLabel":{interval:0,rotate:45,margin:20},
        }],
        "yAxis": [{
          "type": "value",
          name: "工单数",

        }, {
          "type": "value",
          name: "完成率",

        }],
        "series": series_data()
      }
    },

    // 获取业主端投诉情况
    getComplaintReportGatherData(url) {
      let currentDate = new Date()
      let that = this
      var chartDom = document.getElementById('complaintReportGather');
      var myChart = echarts.init(chartDom);
      let where = this.search
      let date = this.search.start_date.split("-")
      if (date != null) {
        where.year = date[0]
        where.month = date[1]
      } else {
        where.year = currentDate.getFullYear();
        where.month = date.getMonth() + 1;
      }
      where.data_range = [this.search.start_date, this.search.end_date]
      where.group_by = 'month'
      where.area_name = where.area
      where.repair_type = where.site
      Http.post(url,
        where,
        res => {
          that.complaintReportGatherLoading = false
          if (res.code) {
            let option = this.complaintReportGatherOption(res.data, '')
            option && myChart.setOption(option);
            myChart.resize()
          }
        })
    },
    complaintReportGatherOption(data, title) {
      const name_list = ["投诉单量"];
      let color_list = ["#409eff"];
      let type = ["bar"];
      let yAxisIndex = [0];
      // 获取战区
      let xData = [];
      // 获取Y轴数据
      let yData = {
        '投诉单量': [],
        '完成率': [],
        '及时率': [],
        '管家满意度': [],
      };
      for (let key in data) {
        xData.push(key);
        yData['投诉单量'].push(data[key]['all_work_order']);
        yData['完成率'].push(data[key]['completion_rate']);
        yData['及时率'].push(data[key]['timeliness_rate']);
        yData['管家满意度'].push(data[key]['satisfaction_good_rate']);
      }
      let series_data = function () {
        return name_list.map((rt, index) => {
          return {
            "name": rt,
            "type": type[index],
            yAxisIndex: yAxisIndex[index],
            "color": color_list[index],
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            "data": yData[rt]
          }
        })
      }
      return {
        "tooltip": {
          "trigger": "axis",
          formatter: function (params) {
            let date = params[0]['axisValue'];
            date = date.slice(0, -1)
            let all_work_order = data[date]['all_work_order']
            let completion_rate = data[date]['completion_rate']
            let timeliness_rate = data[date]['timeliness_rate']
            let satisfaction_good_rate = data[date]['satisfaction_good_rate']

            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:rgba(204,152,54,0.9)"></span>';
            returnData += "投诉单量：" + all_work_order + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + completion_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#ffcc00"></span>';
            returnData += "及时率：" + timeliness_rate + "%</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#cc33ff"></span>';
            returnData += "管家满意度：" + satisfaction_good_rate + "%</br>";
            return returnData;
          }
        },
        "grid": {
          "borderWidth": 0,
          "top": 110,
          "bottom": 95,
          left: 50,
          right: 50,
          textStyle: {
            color: "#949494"
          }
        },
        "legend": {
          x: 'center',
          top: '8%',
          selected: {
            "工单数": true,
            "计划目标数": true,
          },
          "data": name_list
        },


        "calculable": true,
        "xAxis": [{
          "type": "category",
          "axisLine": {
            lineStyle: {
              color: '#90979c'
            }
          },
          "splitLine": {
            "show": false
          },
          "axisTick": {
            "show": true
          },
          "splitArea": {
            "show": false
          },
          "axisLabel":{interval:0,rotate:45,margin:20},
          "data": xData,
        }],

        "yAxis": [{
          "type": "value",
          "splitLine": {
            "show": true
          },
          "axisLine": {
            lineStyle: {
              color: '#90979c'
            }
          },
          "axisTick": {
            "show": true
          },
          "axisLabel": {
            "interval": 0,
          },
          "splitArea": {
            "show": false
          },
          name: "工单数",

        }, {
          "type": "value",
          "splitLine": {
            "show": true
          },
          "axisLine": {
            lineStyle: {
              color: '#90979c'
            }
          },
          "axisTick": {
            "show": true
          },
          "axisLabel": {
            "interval": 0,

          },
          "splitArea": {
            "show": false
          },
          name: "完成率",

        }],
        "series": series_data()
      }
    },

    // 工单未完成量前十名
    getWorkOrderUncompletedData(url, httpType = 'get') {
      let currentDate = new Date()
      let that = this
      var chartDom = document.getElementById('workOrderUncompletedGather');
      var myChart = echarts.init(chartDom);
      let where = this.search
      let date = this.search.start_date.split("-")
      let params = {}
      if (date != null) {
        params.year = date[0]
        params.month = date[0]
      } else {
        params.year = currentDate.getFullYear();
        params.month = date.getMonth() + 1;
      }
      params.data_range = [this.search.start_date,this.search.end_date]
      params.area_name = where.area
      params.repair_type = where.site
      params.project_ids = where.project_ids
      params.group_by = ''
      params.member_type = where.member_type

      if (httpType == 'get') {
        Http.get(url,
          params,
          res => {
            that.workOrderUncompletedGatherLoading = false
            if (res.code) {
              let option = this.workOrderUncompletedOption(res.data)
              option && myChart.setOption(option);
              myChart.resize()
            }
          })
      } else {
        Http.post(url,
          params,
          res => {
            that.workOrderUncompletedGatherLoading = false
            if (res.code) {
              let option = this.workOrderUncompletedOption(res.data)
              option && myChart.setOption(option);
              myChart.resize()
            }
          })
      }

    },
    workOrderUncompletedOption(data) {
      let list = data.sort((a, b) => {
        return b.value - a.value
      })
      const xData = list.map(ret => ret.name);
      const yData = list.map(ret => ret.value);
      return {
        "tooltip": {
          "trigger": "axis",
          "axisPointer": {
            "type": "shadow",
            textStyle: {
              color: "#b6b6b6"
            }

          },
        },
        "grid": {
          "borderWidth": 0,
          "top": 110,
          "bottom": 95,
          textStyle: {
            color: "#949494"
          }
        },
        "legend": {
          x: '4%',
          top: '8%',
          textStyle: {
            color: '#90979c',
          },
          "data": ['女', '男', '平均']
        },
        "calculable": true,
        "xAxis": [{
          "type": "category",
          "axisLabel":{interval:0,rotate:45,margin:20},
          "data": xData,
        }],
        "yAxis": [{
          "type": "value",
        }],
        "series": [
          {
            "name": "未完成量",
            "type": 'bar',
            "color": "rgba(0,191,183,1)",
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            "data": yData
          }
        ]
      }
    },

    // 预警类别分布
    getAlertCategoryData(url, httpType = 'get') {
      let currentDate = new Date()
      let that = this
      var chartDom = document.getElementById('alertCategoryGather');
      var myChart = echarts.init(chartDom);
      let where = this.search
      let params = {}
      let date = this.search.start_date.split("-")
      if (date != null) {
        params.year = date[0]
        params.month = date[1]
      } else {
        params.year = currentDate.getFullYear();
        params.month = date.getMonth() + 1;
      }
      // where.data_range = [this.search.start_date, this.search.end_date]
      // where.area_name = where.area
      // where.repair_type = where.site
      params.data_range = [this.search.start_date, this.search.end_date]
      params.group_by = 'day'
      params.area_name = where.area
      params.repair_type = where.site
      params.project_ids = where.project_ids
      params.member_type = where.member_type

      if (httpType == 'get') {
        Http.get(url,
          params,
          res => {
            that.alertCategoryGatherLoading = false
            if (res.code) {
              let option = this.alertCategoryOption(res.data)
              option && myChart.setOption(option);
              myChart.resize()
            }
          })
      } else {
        Http.post(url,
          params,
          res => {
            that.alertCategoryGatherLoading = false
            if (res.code) {
              let option = this.alertCategoryOption(res.data)
              option && myChart.setOption(option);
              myChart.resize()
            }
          })
      }

    },
    alertCategoryOption(data) {
      let data_list = []
      let list = data
      let color_item_list = ["#038dce", "#56c002", "#fa3161"]
      list.map((ret, index) => {
        data_list[index] = {
          value: ret.value,
          name: ret.name,
          itemStyle: {
            color: color_item_list[index],
          },
          label: {
            formatter: '{b}: {c}个 ({d}%)',
            fontSize: 12,
          }
        }
      })
      return {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `
${params.seriesName} <br/>${params.name} (${params.percent}%)<br/><br/>
总预警: ${params.value}<br/>
  一级: ${list[params.dataIndex].lv1}<br/>
  二级: ${list[params.dataIndex].lv2}<br/>
  三级: ${list[params.dataIndex].lv3}<br/>
`
          }
        },
        series: [
          {
            name: '预警类别分布',
            type: 'pie',
            radius: ['20%', '50%'],
            center: ['50%', '50%'],
            label: {
              show: true,
              normal: {
                position: 'outside',
                fontSize: 16
              }
            },
            labelLine: {
              length: 1,
              length2: 20,
              smooth: true
            },
            data: data_list
          }
        ]
      }
    },

    // 品控中心工单完成率
    getReportRepairGather400Gather(url) {
      let that = this
      var chartDom = document.getElementById('reportRepairGather400Gather');
      var myChart = echarts.init(chartDom);
      let where = this.search
      where.data_range = [this.search.start_date, this.search.end_date]
      where.group_by = "";
      where.area_name = where.area
      where.repair_type = where.site
      if (where.region > 0) {
        where.group_by = "project";
      }
      if (where.project > 0) {
        where.group_by = "area";
      }
      Http.post(url,
        where,
        res => {
          that.reportRepairGatherDayLoading = false
          if (res.code) {
            let option = this.reportRepairGather400GatherOption(res.data, '')
            option && myChart.setOption(option);
            myChart.resize()
          }
        })
    },
    reportRepairGather400GatherOption(data, title) {
      const name_list = ["工单量"];
      let color_list = ["#409eff"];
      let type = ["bar"];
      let yAxisIndex = [0];
      // 获取战区
      let xData = [];
      // 获取Y轴数据
      let yData = {
        '工单量': [],
        '完成率': [],
      };
      for (let key in data) {
        xData.push(key);
        yData['工单量'].push(data[key]['all_work_order']);
        yData['完成率'].push(data[key]['completion_rate']);
      }
      let series_data = function () {
        return name_list.map((rt, index) => {
          return {
            "name": rt,
            "type": type[index],
            yAxisIndex: yAxisIndex[index],
            "color": color_list[index],
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            "data": yData[rt]
          }
        })
      }
      return {
        title:
          {
            left: 'center',
            text: title
          },
        "tooltip": {
          "trigger": "axis",
          formatter: function (params) {
            let date = params[0]['name'];
            let all_work_order = data[date]['all_work_order']
            let completion_rate = data[date]['completion_rate']

            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#3399ff"></span>';
            returnData += "工单数：" + all_work_order + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + completion_rate + "%</br>";
            return returnData;
          }
        },
        "grid": {
          "borderWidth": 0,
          "top": 110,
          "bottom": 95,
          left: 50,
          right: 50,
          textStyle: {
            color: "#949494"
          }
        },
        "legend": {
          x: 'center',
          top: '8%',
          selected: {
            "工单数": true,
          },
          "data": name_list
        },
        "xAxis": [{
          "type": "category",
          "axisLabel":{interval:0,rotate:45,margin:20},
          "data": xData,
        }],
        "yAxis": [{
          "type": "value",
          name: "工单数",
        }],
        "series": series_data()
      }
    },

    // 品控中心工单类型分布
    getAlertCategory400Data(url) {
      let currentDate = new Date()
      let that = this
      var chartDom = document.getElementById('alertCategory400Gather');
      var myChart = echarts.init(chartDom);
      let where = this.search
      let date = this.search.start_date.split("-")
      if (date != null) {
        where.year = date[0]
        where.month = date[1]
      } else {
        where.year = currentDate.getFullYear();
        where.month = date.getMonth() + 1;
      }
      where.data_range = [this.search.start_date, this.search.end_date]
      where.area_name = where.area
      where.repair_type = where.site
      Http.post(url,
        where,
        res => {
          if (res.code) {
            let option = this.alertCategory400Option(res.data)
            option && myChart.setOption(option);
            myChart.resize()
          }
        })
    },
    alertCategory400Option(data) {
      let data_list = []
      let list = data
      let color_item_list = ["#038dce", "#56c002", "#fa3161"]
      list.map((ret, index) => {
        data_list[index] = {
          value: ret.value,
          name: ret.name,
          itemStyle: {
            color: color_item_list[index],
          },
          label: {
            formatter: '{b}: {c}个 ({d}%)',
            fontSize: 12,
            // position: 'inside',
          }
        }
      })
      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}个 ({d}%)'
        },
        series: [
          {
            // name: '工单未完成量后十名情况',
            type: 'pie',
            radius: ['20%', '50%'],
            center: ['50%', '50%'],
            label: {
              show: true,
              normal: {
                position: 'outside',
                fontSize: 16
              }
            },
            labelLine: {
              length: 1,
              length2: 20,
              smooth: true
            },
            data: data_list
          }
        ]
      }
    },
    getRepairAchievements() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      if (this.search.project_ids == '') {
        // let projectIds = [];
        // for (const k in this.search.region_list) {
        //   let item = this.search.region_list[k]
        //   let list = this.getProjectListByRegion(item.id)
        //   projectIds.push(list.map(item => item.erp_pindex_id))
        // }
        // this.search.project_ids = projectIds.join(',');
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.search.export = 0
      this.loading = true
      this.$myhttp.post('admin/getRepairAchievements', this.search, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];
        if (resData.code == 200) {
          this.tableData = resData.data
        }
      });
    },
    getRepairAchievementsTotal() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      if (this.search.project_ids == '') {
        // let projectIds = [];
        // for (const k in this.search.region_list) {
        //   let item = this.search.region_list[k]
        //   let list = this.getProjectListByRegion(item.id)
        //   projectIds.push(list.map(item => item.erp_pindex_id))
        // }
        // this.search.project_ids = projectIds.join(',');
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.search.export = 0;
      this.loading = true
      this.$myhttp.post('admin/getRepairAchievementsTotal', this.search, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];
        if (resData.code == 200) {
          this.tableAllData = resData.data
        }
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      console.info(data)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.totalTitle;
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = _.round(sums[index], 2)
        } else {
          sums[index] = 'N/A';
        }
      });
      sums[28] = 0;
      data.forEach(item => {
        sums[28] += Number(item['visit_count'])
      })
      if (sums[15] > 0) {
        sums[28] = _.round((sums[28] / sums[15])*100, 2)
      } else {
        sums[28] = 0
      }

      if (this.totalTitle !== '区域小计') {
        sums[4] = "-";
      }
      if (this.totalTitle !== '战区小计') {
        sums[5] = "-";
      }
      if (this.totalTitle == '物业小计') {
        sums[5] = "-";
      }
      // sums[18] = "-";
      // sums[25] = "-";
      // 公共安全事务-完成率
      sums[8] = sums[6] != 0 ? _.round((sums[7] / sums[6])*100 ,2) : 0
      // 日清日毕-完成率
      sums[11] = sums[9] != 0 ? _.round((sums[10] / sums[9])*100, 2) : 0
      // 报事报修（居家+公区维修）-完成率
      sums[14] = sums[12] != 0 ? _.round((sums[13] / sums[12])*100, 2) : 0
      // 报事报修-完成率
      sums[18] = sums[15] != 0 ? _.round((sums[16] / sums[15])*100, 2) : 0
      // 报事报修-优良率
      sums[19] = sums[15] != 0 ? _.round((sums[17] / sums[15])*100, 2) : 0

      // 投诉事务-完成率
      sums[23] = sums[20] != 0 ? _.round((sums[21] / sums[20])*100, 2) : 0
      // 投诉事务-优良率
      sums[24] = sums[20] != 0 ? _.round((sums[22] / sums[20])*100, 2) : 0
      // 报事报修+投诉合计-完成率
      //sums[24] = sums[22] != 0 ? _.round((sums[23] / sums[22])*100, 2) : 0

      // 计算   报事报修+投诉合计-完成率
      // * 1.投诉工单数大于0，完成率=（报事报修完成率+投诉完成率)/2
      //* 2.投诉工单数小于1，完成率=报事报修完成率
      if(sums[20] > 0) {
        sums[27] = _.round( (sums[23] + sums[18]) / 2 , 2)
      } else {
        sums[27] = _.round(sums[18], 2)
      }


      // 计算   优良率
      // 实际工单数（报事报修+投诉）合计   > 基准数
      if (sums[27] >= 80 && sums[25] >= sums[1]) {
        if(sums[20] > 0){
          sums[5] = _.round( (sums[19] + sums[24]) / 2 , 2)
        } else {
          sums[5] = _.round(sums[19], 2)
        }
      } else {
        sums[5] = 0
      }


      sums[5] = sums[5].toFixed(2)
      sums[8] = sums[8].toFixed(2)
      sums[11] = sums[11].toFixed(2)
      sums[14] = sums[14].toFixed(2)
      sums[18] = sums[18].toFixed(2)
      sums[19] = sums[19].toFixed(2)
      sums[23] = sums[23].toFixed(2)
      sums[24] = sums[24].toFixed(2)
      sums[27] = sums[27].toFixed(2)
      sums[28] = sums[28].toFixed(2)
      return sums;
    },
    handleClick(tab, event) {
      this.showButton = false
      if (tab['name'] === "first") {
        this.$nextTick(() => {
          this.createChart()
        });
      }
      if (tab['name'] === "third") {
        this.getRepairAchievementsTotal()
      }
      if (tab['name'] === "four") {
        this.showButton = true
        this.getRepairAchievements()
      }
      if (tab['name'] === "five") {
        this.getOwnerWorkOrderData()
      }
      if (tab['name'] === "abnormalWork") {
        // this.getRepairAbnormalList()
      }
    },
    exportGather() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.search.export = 1;
      this.loading = true
      this.$myhttp.post('admin/getRepairAchievements', this.search, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];
        if (resData.code == 200) {
          window.open("https://api.oa.gdzawy.com:9001" + resData.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      });
    },
    exportReportAbnormal() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.search.export = 1;
      this.loading = true
      this.$myhttp.post('admin/getReportAbnormal', this.search, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];
        if (resData.code == 200) {
          window.open("https://api.oa.gdzawy.com:9001" + resData.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      });
    },
    exportReportAbnormalSummary() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.search.export = 1;
      this.loading = true
      this.$myhttp.post('admin/getReportAbnormalSummary', this.search, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];
        if (resData.code == 200) {
          window.open("https://api.oa.gdzawy.com:9001" + resData.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      });
    },
    // 获取业主工单数据
    getOwnerWorkOrderData() {
      const that = this;
      that.ownerWorkOrderLoading = true;
      // 准备请求参数
      let params = {
        start_date: that.search.dateArr.length > 0 ? that.search.dateArr[0] : '',
        end_date: that.search.dateArr.length > 1 ? that.search.dateArr[1] : '',
        page: that.ownerWorkOrderCurrentPage,
        page_size: that.ownerWorkOrderPageSize,
        project_id: that.search.project_id || '',
        project_ids: that.search.project_ids || ''
      };
      
      // 调用API获取数据
      that.$myhttp.post('admin/getOwnerWorkOrderList', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        that.ownerWorkOrderLoading = false
        let resData = backdata['data'];
        if (resData.code == 200) {
          that.ownerWorkOrderData = resData.data || [];
          that.ownerWorkOrderTotal = resData.count || 0;
          that.ownerWorkOrderCurrentPage = resData.page || 1;
          that.ownerWorkOrderPageSize = resData.page_size || 20;
        } else {
          that.ownerWorkOrderData = [];
          that.ownerWorkOrderTotal = 0;
        }
        that.ownerWorkOrderLoading = false;
      });
    },
    // 业主工单分页变化
    ownerWorkOrderPageChange(currentPage) {
      this.ownerWorkOrderCurrentPage = currentPage;
      this.getOwnerWorkOrderData();
    },
    getReportAbnormalType() {
      this.$myhttp.get('admin/getReportAbnormalType', this.search, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => { // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];

        if (resData.code == 200) {
          this.abnormalDataType = resData.data
        }
      });
    },

    getComplaintDayChart() {
      let chartDom = document.getElementById('complaintDay');
      let myChart = echarts.init(chartDom);
      let params = {}
      params.project_ids = this.search.project_ids
      params.group_by = 'day'
      params.start_date = this.search.start_date
      params.end_date = this.search.end_date
      params.type = this.search.type
      this.$myhttp.post('admin/getComplaintChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let list = _.sortBy(resData.list, ['bill_date'])
          let xData = []
          let yData = {}
          let totalData = []
          let finishData = []
          let finishEateData = []
          _.forEach(list, function (item) {
            let finish_rate = (item['all_finish_count'] / item['all_total_count']) * 100
            xData.push(item.date_name)
            totalData.push(item.all_total_count)
            finishData.push(item.all_finish_count)
            finishEateData.push(_.round(finish_rate, 2))
            yData[item.date_name] = item
          })
          let  seriesData = [{
            name: '投诉量',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: totalData
          },{
            name: '完成率',
            type: 'line',
            yAxisIndex: 1,
            label: {
              show: false,
              fontWeight: 'bold',
              position: 'top',
            },
            data: finishEateData
          }]
          let formatter = function (params) {
            let date = params[0]['name'];
            let finish_rate = (yData[date]['all_finish_count'] / yData[date]['all_total_count']) * 100
            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#3399ff"></span>';
            returnData += "工单数：" + yData[date]['all_total_count'] + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + _.round(finish_rate, 2) + "%</br>";
            return returnData;
          }
          let option = this.echartsOptionBar(xData, '日期', yData, '工单数', seriesData, formatter)
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    getComplaintWarningDayChart() {
      var chartDom = document.getElementById('complaintWarningDay');
      var myChart = echarts.init(chartDom);
      let params = {}
      params.project_ids = this.search.project_ids
      params.group_by = 'day'
      params.start_date = this.search.start_date
      params.end_date = this.search.end_date
      params.type = this.search.type
      this.$myhttp.post('admin/getComplaintWarningDayChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let list = _.sortBy(resData.list, ['bill_date'])
          let xData = []
          let yData = {}
          let w1 = []
          let w2 = []
          let w3 = []
          _.forEach(list, function (item) {
            xData.push(item.date_name)
            yData[item.date_name] = item
            w1.push(item.all_timeout1_count)
            w2.push(item.all_timeout2_count)
            w3.push(item.all_timeout3_count)
          })


          let  seriesData = [{
            name: '一级预警',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: w1
          },{
            name: '二级预警',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: w2
          },{
            name: '三级预警',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: w3
          }]
          let option = this.echartsOptionBar(xData, '日期', yData, '工单数', seriesData, {})
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    getComplaintMonthChart() {
      let chartDom = document.getElementById('complaintMonth');
      let myChart = echarts.init(chartDom);
      let params = {}
      params.project_ids = this.search.project_ids
      params.group_by = 'month'
      // 获取第一个日期的年份
      params.year = this.search.start_date.substring(0, 4);
      params.type = this.search.type
      this.$myhttp.post('admin/getComplaintChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let list = _.sortBy(resData.list, ['bill_date'])
          let xData = []
          let yData = {}
          let totalData = []
          let finishData = []
          let finishEateData = []
          _.forEach(list, function (item) {
            let finish_rate = (item['all_finish_count'] / item['all_total_count']) * 100
            xData.push(item.year_month)
            totalData.push(item.all_total_count)
            finishData.push(item.all_finish_count)
            finishEateData.push(_.round(finish_rate, 2))
            yData[item.year_month] = item
          })
          let  seriesData = [{
            name: '投诉量',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: totalData
          },{
            name: '完成率',
            type: 'line',
            yAxisIndex: 1,
            label: {
              show: false,
              fontWeight: 'bold',
              position: 'top'
            },
            data: finishEateData
          }]
          let formatter = function (params) {
            let date = params[0]['name'];
            let finish_rate = (yData[date]['all_finish_count'] / yData[date]['all_total_count']) * 100
            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#3399ff"></span>';
            returnData += "工单数：" + yData[date]['all_total_count'] + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + _.ceil(finish_rate, 2) + "%</br>";
            return returnData;
          }
          let option = this.echartsOptionBar(xData, '日期', yData, '工单数', seriesData, formatter)
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    getComplaintRankingChart() {
      let that = this
      let chartDom = document.getElementById('complaintRanking');
      let myChart = echarts.init(chartDom);
      let params = {}
      params.group_by = 'project'
      if (this.search.region > 0) {
        params.group_by = 'project'
      }
      if (this.search.project > 0) {
        params.group_by = 'area'
      }
      params.start_date = this.search.start_date
      params.end_date = this.search.end_date
      params.project_ids = this.search.project_ids
      params.type = this.search.type
      this.$myhttp.post('admin/getComplaintChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let list = resData.list
          let xData = []
          let yData = {}
          let totalData = []
          let finishData = []
          _.forEach(list, function (item) {
            if (that.search.project > 0) {
              xData.push(item.area_name)
              yData[item.area_name] = item
            } else {
              xData.push(item.project_name)
              yData[item.project_name] = item
            }
            totalData.push(item.all_total_count)
            finishData.push(item.all_finish_count)
          })
          let  seriesData = [{
            name: '投诉量',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: totalData
          }]
          let formatter = function (params) {
            let date = params[0]['name'];
            let finish_rate = (yData[date]['all_finish_count'] / yData[date]['all_total_count']) * 100
            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#3399ff"></span>';
            returnData += "工单数：" + yData[date]['all_total_count'] + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + _.ceil(finish_rate, 2) + "%</br>";
            return returnData;
          }
          let option = this.echartsOptionBar(xData, '日期', yData, '工单数', seriesData, formatter)
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    getComplaintTypeChart(){
      let that = this
      this.chartTypeData = {}
      let chartDom = document.getElementById('complaintType');
      let myChart = echarts.init(chartDom);
      let params = {}
      params.start_date = this.search.start_date
      params.end_date = this.search.end_date
      params.project_ids = this.search.project_ids
      this.$myhttp.post('admin/getComplaintTypeChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let item = resData.list[0]
          let yData = {}
          // 计算占比
          this.chartTypeData = item
          let total = parseInt(item.all_ggsw_total_count, 10) + parseInt(item.all_wyfw_total_count, 10) + parseInt(item.all_dcfw_total_count, 10)  + parseInt(item.all_gqaq_total_count, 10)
          let ggsw = item.all_ggsw_total_count === 0 ? 0.00 : _.round((item.all_ggsw_total_count / total) * 100, 2)
          let wyfw = item.all_wyfw_total_count === 0 ? 0.00 : _.round((item.all_wyfw_total_count / total) * 100, 2)
          let dcfw = item.all_dcfw_total_count === 0 ? 0.00 : _.round((item.all_dcfw_total_count / total) * 100, 2)
          let gqaq = item.all_gqaq_total_count === 0 ? 0.00 : _.round((item.all_gqaq_total_count / total) * 100, 2)
          let  seriesData = [ {
            name: '投诉类型分布',
            type: 'pie',
            radius: '50%',
            data: [
              { value: ggsw, name: '公区卫生绿化 ' +  ggsw + '%'},
              { value: wyfw, name: '服务态度 ' +  wyfw + '%' },
              { value: dcfw, name: '公区维修 ' +  dcfw + '%' },
              { value: gqaq, name: '公区安全 ' +  gqaq + '%' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
          let formatter = function (params) {
            let returnData = "";
            let total_count = "";
            let finish_count = "";
            let key = params['name'];
            let checkGgsw = key.includes('公区卫生绿化')
            let checkWyfw = key.includes('服务态度')
            let checkDcfw = key.includes('公区维修')
            if (checkGgsw) {
              total_count = that.chartTypeData.all_ggsw_total_count
              finish_count = that.chartTypeData.all_ggsw_finish_count
            }
            if (checkWyfw) {
              total_count = that.chartTypeData.all_wyfw_total_count
              finish_count = that.chartTypeData.all_wyfw_finish_count
            }
            if (checkDcfw) {
              total_count = that.chartTypeData.all_dcfw_total_count
              finish_count = that.chartTypeData.all_dcfw_finish_count
            }
            returnData = `
                    ${key} <br/><br/>
                        工单量: ${total_count}<br/>
                        已完成: ${finish_count}<br/>
            `
            return returnData;
          }
          let option = this.echartsOptionPie([], '', yData, '', seriesData, formatter)
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    echartsOptionBar(xData, xTitle, yData, yTitle, seriesData, formatter) {
      let tooltip = {}
      if (typeof formatter === 'function') {
        tooltip = {
          formatter: function (params) {
            return formatter(params)
          }
        }
      }
      tooltip.trigger = 'axis'

      let yAxis = [{
        type: 'value',
        name: yTitle,
        nameGap: 30,
        axisLabel: {
          formatter: '{value}'
        }
      },{
        type: 'value',
        name: '',
        nameGap: 30,
        axisLabel: {
          formatter: '{value}' + '%'
        }
      }]
      let option = {
        tooltip: tooltip,
        legend: {
          show: true
        },
        grid: {
          left: '2%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel:{interval:0,rotate:45,margin:20},
          name: xTitle,
          data: xData,
          axisPointer: {
            type: 'shadow'
          }
        },
        yAxis: yAxis,
        series: seriesData
      }
      return option;
    },
    echartsOptionPie(xData, xTitle, yData, yTitle, seriesData, formatter) {
      let tooltip = {}
      if (typeof formatter === 'function') {
        tooltip = {
          formatter: function (params) {
            return formatter(params)
          }
        }
      }
      tooltip.trigger = 'item'
      let option = {
        tooltip: tooltip,
        legend: {
          show: true
        },
        grid: {
          left: '2%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel:{interval:0,rotate:45,margin:20},
          name: xTitle,
          data: xData,
          axisPointer: {
            type: 'shadow'
          }
        },
        yAxis: {
          type: 'value',
          name: yTitle,
          nameGap: 30,
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: seriesData
      }
      return option;
    },
  },

}
</script>
<style scoped>
.el-row {
  margin-bottom: 10px;
}

.ti {
  margin: 1%;
  width: 98%;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
}

</style>

<style lang="scss" scoped>
.tab-scroll-content {
  height: calc(100vh - 350px);
  overflow-y: auto;
  overflow-x: auto;
}

::v-deep .tableBox {
  .el-table__header-wrapper {
    th {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: bold;
    }
  }
  .el-table__footer-wrapper {
    td {
      background-color: #e6f7ff;
      color: #606266;
      font-weight: bold;
    }
  }
}

.body {
  display: flex;
  flex-direction: column;
  background-color: aliceblue;

  .body-item {
    .body-item-header {
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
    }

    .body-item-main {
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.visit1 {
  width: calc(50% - 30px);
  height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart1 {
    width: calc(100% - 30px);
    height: calc(448px - 80px);
  }

  .visit-chart3 {
    width: 400px;
    height: 400px;
  }

  .visit-title {
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-header {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;

    .m-2 {
      width: 100px;
    }
  }
}


.visit2 {
  width: calc(100% - 40px);
  height: calc(500px - 30px);
  margin: 10px;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart2 {
    width: 100%;
    //width: 800px;
    height: calc(448px - 30px);
  }

  .visit-title {
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-header {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;

    .m-2 {
      width: 100px;
    }
  }
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 9999;
  box-shadow: 0 3px 5px -2px #cccccc69;
}

.chart-item {
  box-sizing: border-box;
  margin: 5px;
  width: calc(100% - 10px);
  background: #fff;
  border-radius: 5px;
  padding: 10px;
}

.tableBox th {
  padding: 0 !important;
  height: 50px;
  line-height: 30px;
  text-align: center;
}

.tableBox td {
  padding: 0 !important;
  height: 40px;
  line-height: 30px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Repair/Repairs.vue